import { useState } from "react";
import "../assests/Login.css";
import { Button, Spin } from "antd";
import { CopyrightOutlined, EyeInvisibleOutlined, EyeTwoTone, LoadingOutlined } from "@ant-design/icons";
import Logo from "../assests/Culsight Logo (1) (1).png";
import { AxiosFirst } from "../config/config";
import Link from "antd/es/typography/Link";
 
const Login = () => {
    const [loader, setLoader] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
 
    const togglePasswordVisibility = () => {
        setShowPassword(prev => !prev);
    };
 
    const LOGIN_ACCOUNT = async () => {
        setLoader(true);
        try {
            const formData = new FormData();
            formData.append("email", email);
            formData.append("password", password);
 
            const res = await AxiosFirst.post("login-view/", formData);
 
            if (res?.data?.status) {
                 window.location.href = "/";
            } else {
                setError(res.data.error || "Login failed");
            }
        } catch (err) {
            console.log(err);
            setError("Network error");
        }
        setLoader(false);
    };
    return (
        <>
            <div className="login-wapper">
                <div className="login-form" style={{ marginTop: "70px", padding: "20px 50px 50px 50px" }}>
                    <img alt="logo" src={Logo} style={{ maxWidth: "200px" }} />
                    <p>Enter your details to sign in to your account</p>
                    {error && <p style={{ color: "red", fontWeight: "bold" }}>{error}</p>}
 
                    <input
                        className="black-input"
                        placeholder="Email Address"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                    <div style={{ position: "relative" }}>
                        <input
                            type={showPassword ? "text" : "password"}
                            className="black-input"
                            placeholder="Password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                        />
                        {showPassword ?
                            <EyeTwoTone className="password-eye" onClick={togglePasswordVisibility} /> :
                            <EyeInvisibleOutlined className="password-eye" onClick={togglePasswordVisibility} />
                        }
                    </div>
 
                    {/* <Link to="/forget-password" className="lms-link right" style={{ position: "relative", top: "-18px", left: "145px", color: "#fff" }}>
                        Forgot Password?
                    </Link> */}
 
                    {loader ?
                        <Button type="primary" style={{ width: "100%", height: "42px",backgroundColor: "#8c3add" }}>
                            <Spin indicator={<LoadingOutlined spin />} style={{ color: "#FFF" }} size="small" />
                        </Button> :
                        <Button type="primary" onClick={LOGIN_ACCOUNT} style={{ width: "100%", height: "42px",backgroundColor: "8c3add"}}>
                            Sign In
                        </Button>
                    }
 
 
                </div>
 
                <div className="login-footer">
                    <div style={{ marginLeft: "15px" }}>
                        Copyright <CopyrightOutlined /> {new Date().getFullYear()} Culsight
                    </div>
                    <div style={{ marginRight: "15px" }}>
                        <Link to="#" className="lms-link" style={{ color: "#0f0f0f" }}>Terms & Policies</Link>
                    </div>
                </div>
            </div>
        </>
    );
};
export default Login;
 